<template>
  <div ref="resultPage"  style="height: 100%; display: flex; flex-direction: column">
    <Form ref="filterForm" :label-width="100" :model="filter">
      <Row :gutter="8" class="last-row">
        <Col span="6">
          <FormItem label="选择项目" prop="projectId">
            <Select v-model="filter.projectId" placeholder="请选择项目">
              <Option :value="item.projectId" v-for="item in $coreData.projectList" :key="item.projectID">
                {{item.projectId + ' - ' + item.projectName}}
              </Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem label="终端起始ID"  prop="startDeviceId">
            <Input v-model="filter.startDeviceId" placeholder="请输入数字序列"/>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem label="终端结束ID"  prop="endDeviceId">
            <Input v-model="filter.endDeviceId" placeholder="请输入数字序列"/>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem  style="margin-left: -100px">
            <Button type="primary" style="margin-left: 8px; width: 90px" @click="handleFilterDone">查询</Button>
            <Button style="margin-left: 8px; width: 90px"  @click="handleFilterReset">重置</Button>
            <Button style="margin-left: 8px; width: 90px"  @click="handleExport">导出</Button>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <div style="margin-top: 16px; display:flex; flex-direction: column; flex-grow: 1">
      <Table class="table" ref="refTable" size="default" stripe border highlight-row :data="resultList" :columns="columns" height="486px">
        <template slot-scope="{row, index}" slot="index">
          <div>{{(pageIndex-1)*pageSize + index + 1}}</div>
        </template>
        <template slot-scope="{row, index}" slot="result">
          <div>{{formatResult(row)}}</div>
        </template>
        <template slot-scope="{row, index}" slot="time">
          <div>{{formatTime(row.time)}}</div>
        </template>
      </Table>
      <div v-show="totalCount > 0">
        <Page class="table-page" :show-total="true" :total="totalCount" :page-size="pageSize" :current="pageIndex" @on-change="changePage"></Page>
      </div>
    </div>
  </div>
</template>

<script>
  import hsqPanel from "../components/hsqPanel";
  import {formatDateTime, deepCopyObject} from "../utility/util";

  export default {
    components: {
      hsqPanel
    },
    data() {
      return {
        pageHeight: 0,
        resultList: [],
        totalCount: 10,
        pageIndex: 1,       //当前页面，从1开始
        pageSize: 10,       //每页显示多少条记录
        filter: {
          projectId: '',
          startDeviceId: '',
          endDeviceId: ''
        },
        columns: [
          {
            //fixed: 'left',
            title: '序号',
            width: 80,
            // align: 'center',
            slot: 'index'
          }, {
            title: '设备编号',
            minWidth: 200,
            key: 'deviceId'
          }, {
            title: '升级结果',
            minWidth: 200,
            key: 'result',
            slot: 'result'
          }, {
            title: '旧固件版本',
            minWidth: 200,
            key: 'oldCodeId'
          }, {
            title: '新固件版本',
            minWidth: 200,
            key: 'newCodeId'
          }, {
            title: '时间',
            minWidth: 200,
            key: 'time',
            slot: 'time'
          }
        ]
      }
    },
    mounted() {
      console.log('result page mounted');
      this.pageHeight = this.$refs['resultPage'].offsetHeight;
      console.log('pageHeight', this.pageHeight);

      deepCopyObject(this.filter, this.$coreData.updateResult.searchSetting);
      if (this.$coreData.updateResult.resultList.length > 0) {
        this.changePage(1);
      } else {
        // this.getData();
      }
    },
    created() {
      console.log('result page created');
    },
    destroyed() {
      console.log('result page destroyed');
      deepCopyObject(this.$coreData.updateResult.searchSetting, this.filter);
      console.log(this.$coreData.updateResult.searchSetting);
    },
    methods: {
      formatResult(data) {
        let res = '';
        if (data.newCodeId) {
          if (data.result) {
            res = '成功';
          } else {
            res = '失败';
          }
        } else {
          res = '未知';
        }
        return res;
      },
      formatTime(time) {
        return formatDateTime(new Date(time));
      },
      handleFilterDone() {
        this.getData();
      },
      handleFilterReset() {
        // this.$refs['filterForm'].resetFields();
        this.filter.projectId = '';
        this.filter.startDeviceId = '';
        this.filter.endDeviceId = '';
        this.getData();
      },
      handleExport() {
        if (this.resultList.length > 0) {
          let exportData = [];
          // deepCopyObject(exportData, this.resultList);
          deepCopyObject(exportData, this.$coreData.updateResult.resultList);
          exportData.forEach(item => {
            item.time = this.formatTime(item.time);
            item.result = this.formatResult(item);
          });
          console.log('exportData', exportData);
          console.log('this.resultList', this.resultList);

          this.$refs['refTable'].exportCsv({
            filename: `升级结果`,
            columns: this.columns.filter((col, index) => index > 0),    //不导出序列号
            data: exportData.filter((data, index) => true)
          });

          this.$Message.success('数据导出成功');
        } else {
          this.$Message.error('没有数据');
        }
      },
      changePage(pageIndex) {
        console.log(pageIndex);
        this.pageIndex = pageIndex;
        let list = this.$coreData.updateResult.resultList;
        let index = (this.pageIndex - 1) * this.pageSize;
        this.resultList = list.slice(index, index + this.pageSize);
      },
      getData() {
        let config = {
          filter: this.filter
        };
        this.$coreData.getResultList(config, (res, msg) => {
          if (res === 'success') {
            this.totalCount = this.$coreData.updateResult.resultList.length;
            this.changePage(1);   //数据更新后，重新切换到第一页
          } else {
            console.log(msg);
          }
        });
      }
    }
  }
</script>

<style scoped>
.last-row .ivu-form-item {
  margin-bottom: 0 !important;
}

.table-page {
  text-align: right;
  margin: 10px;
}

</style>